export const ActionTypes = {
  LOADING: "GET_MASTER_PROGRESS_LOADING",
  ERROR: "GET_MASTER_PROGRESS_ERROR",
  SUCCESS: "GET_MASTER_PROGRESS_SUCCESS"
};
